import $ from 'jquery';
import Dropzone from 'dropzone';

$(function() {

    $('.js-upload-modal').on('click', event => {

        const $modal = $('.modal');

        // Grab titles and id's
        const $self = $(event.currentTarget);
        const $row = $self.parents('.artwork-row');
        const title = $row.find('.artwork-row__title').text();
        const subtitle = $row.find('.artwork-row__subtitle').text();
        const artworkId = $row.attr('data-id');
        const numberOfDesigns = parseInt($self.parents('.artwork-row').attr('data-number-designs'));

        // Store ID's for later use.
        const $dropzone = $modal.find('.modal__dropzone');
        $dropzone.attr('data-id', artworkId);

        // Update modal title
        $modal.find('.modal__title').text(title);
        $modal.find('.modal__subtitle').text(subtitle);

        // Init dropzone
        window.artworkDropzone = new Dropzone('.js-upload-dropzone', {
            url: '/wp-admin/admin-ajax.php?action=handle_artwork_upload',
            paramName: "file",
            maxFileSize: 256,
            maxFiles: numberOfDesigns ?? 1,
        });

        // Add on extra data when dropzone image is sent
        window.artworkDropzone.on('sending', function(file, xhr, formData) {
            formData.append("artwork_id", artworkId);
        });

        // When file uploaded, store the file path in modal ready for submit
        window.artworkDropzone.on('success', function(file) {
            const response = JSON.parse(file.xhr.response);
            file.previewElement.dataset.fileName = response.file_name;
            file.previewElement.dataset.originalFileName = response.original_file_name;
        });

        // Display Modal
        $('.overlay').addClass('active');
        $('.js-artwork-modal').addClass('active');

    });

    $('.js-upload-close').on('click', closeArtworkModal);

    $('.js-upload-submit').on('click', event => {

        // Take the uploaded file name and order id/productid/attribute id and submit
        const $modal = $('.modal__dropzone');
        const instructions = $(`.js-artwork-modal .js-artwork-instructions`).val();

        if (instructions === '') {
            $('.upload-art-info__error').addClass('active');
            return;
        }

        // Init data object
        const data = {
            artwork_id: $modal.attr('data-id'),
            instructions: instructions,
            files: []
        };

        // Iterate over each dropzone item getting data
        $(`.js-upload-dropzone[data-id="${data.artwork_id}"] .dz-preview.dz-complete`).each(function() {
            const fileName = $(this).attr('data-file-name');
            const originalFileName = $(this).attr('data-original-file-name');
            data.files.push({
                file_name: fileName,
                original_file_name: originalFileName,
            })
        });

        $.ajax({
           url: '/wp-admin/admin-ajax.php?action=handle_artwork_submit',
           method: 'POST',
           data: { ...data },
           success: function (response) {
               if (response.success) {
                   const $row = $(`.artwork-row[data-id="${data.artwork_id}"]`);
                   $row.find('.artwork-row__status').html(response.status_html);
                   $row.find('.js-upload-modal').hide();
                   $('.upload-art-info__error').removeClass('active');
                   closeArtworkModal();
               }
            }
        });

    });

    // Remove uploaded artwork
    $(document).on('click', '.modal__dropzone .dz-complete.dz-success', function() {

       const fileName = $(this).attr('data-file-name');

       $.ajax({
           url: '/wp-admin/admin-ajax.php?action=handle_artwork_delete',
           type: 'POST',
           data: {
               'file': fileName
           },
           success: function(response) {
               if (response.deleted) {
                   const files = window.artworkDropzone.getAcceptedFiles();
                   window.artworkDropzone.removeFile(files[0]);
               }
           }
       })

    });

    // Remove failed artwork
    $(document).on('click', '.modal__dropzone .dz-complete.dz-error', function() {

        // Grab dropzone before deleting
        const $dropzone = $(this).parents('.dropzone');

        // Remove item from dropzone
        $(this).remove();

        // If no items left, display upload message
        if ($dropzone.children('.dz-preview').length === 2) {
            $dropzone.removeClass('dz-started');
        }

    });

    $('.js-send-artwork').on('click', function() {
        $.ajax({
            url: '/wp-admin/admin-ajax.php?action=handle_artwork_send',
            method: 'POST',
            data: {
                order_id: getOrderIdFromUrl(),
            },
            success: function(response) {
                if (response.success) {
                    $('.artwork-sent').addClass('active');
                }
            },
        })
    });

    $('.js-upload-cancel').on('click', function() {

        // Close are you sure modal
        $('.js-are-you-sure-modal').removeClass('active');
        $('.js-artwork-modal').removeClass('modal-faded');

        // Destroy dropzone on close
        window.artworkDropzone.destroy();

        // Close Modal
        $('.overlay').removeClass('active');
        $('.js-artwork-modal').removeClass('active');
        $('.upload-art-info__error').removeClass('active');

    });

    $('.js-upload-continue').on('click', function() {
        $('.js-artwork-modal').removeClass('modal-faded');
        $('.js-are-you-sure-modal').removeClass('active');
    });

    // Pattern handlers/methods

    $('.js-select-pattern').on('click', function () {

        // Get the pattern count
        const patternCount = $(this).parents('.artwork-row').attr('data-number-designs');
        $('.js-pattern-modal-count').text(patternCount);

        // Get the artwork ID
        const artworkId = $(this).parents('.artwork-row').attr('data-id');
        $('.js-pattern-modal').attr('data-id', artworkId);

        // Setup slots
        $('.js-pattern-slots').empty();
        for (let i = 0; i < patternCount; i++) {
            const $clone = $('.js-pattern-slots ~ .pattern-slot').clone();
            $clone.find('.pattern-slot__num').text(`#${i+1}`);
            $clone.attr('data-number', i + 1);
            $clone.appendTo('.js-pattern-slots');
        }
        $('.js-pattern-slots > .pattern-slot').show();

        // Open modal
        $('.overlay').addClass('active');
        $('.js-pattern-modal').addClass('active');

    })

    $('body').on('click', '.js-open-pattern-select', function() {

        // Grab parent modal and slot number
        const $parent = $(this).parents('.pattern-slot');
        const slotNumber = $parent.attr('data-number');

        // Fade out parent modal
        $parent.parents('.modal').css('opacity', 0.5)

        // Open pattern select modal
        $('.pattern-select').attr('data-slot', slotNumber);
        $('.pattern-select').addClass('active');

    });

    $('.js-pattern-submit').on('click', event => {

        // Take the uploaded file name and order id/productid/attribute id and submit
        const instructions = $(`.js-pattern-modal .js-artwork-instructions`).val();

        if (instructions === '') {
            $('.upload-art-info__error').addClass('active');
            console.log('mission failed, no instructions found');
            return;
        }

        const patterns = [];
        $('.pattern-slot').each(function() {
            if ($(this).attr('data-id') !== '') {
                patterns.push({
                    id: $(this).attr('data-id'),
                    number: $(this).attr('data-number'),
                    name: $(this).attr('data-name'),
                });
            }
        });

        // Init data object
        const data = {
            artwork_id: $('.js-pattern-modal').attr('data-id'),
            instructions: instructions,
            patterns: patterns,
        };

        $.ajax({
            url: '/wp-admin/admin-ajax.php?action=handle_artwork_submit',
            method: 'POST',
            data: { ...data },
            success: function (response) {
                if (response.success) {
                    const $row = $(`.artwork-row[data-id="${data.artwork_id}"]`);
                    $row.find('.artwork-row__status').html(response.status_html);
                    $('.pattern-grid__error').removeClass('active');
                    $('.js-pattern-modal').removeClass('active');
                    $('.overlay').removeClass('active');
                    _patternDesignWidget.showTopLevel();
                }
            }
        });

    });

    $('body').on('click', '.pattern-select .patternDesignDesign', function() {
        $('.js-pattern-selector').removeClass('btn-disabled');
    });

    $('body').on('click', '#patternDesignBackToOverview', function () {
        $('.js-pattern-selector').addClass('btn-disabled');
    });

    $('.js-pattern-selector').on('click', function() {

        // Get data
        const { id, title } = _patternDesignWidget.selectedDesign;
        const $patternModal = $(this).parents('.pattern-select');
        const slotNumber = $patternModal.attr('data-slot');
        const imageUrl = $('#patternDesignRepeatView').css('background-image').replace(/^url\(["']?/, '').replace(/["']?\)$/, '');;

        // Fill attributes on artwork row
        const $row = $(`.js-pattern-slots .pattern-slot[data-number="${slotNumber}"]`);
        $row.attr('data-id', id);
        $row.attr('data-name', title);
        $row.find('.pattern-slot__img').attr('src', imageUrl);
        $row.find('.pattern-slot__img').show();
        $row.find('.pattern-slot__name').text(title);
        $row.find('.js-open-pattern-select').hide();

        // Reset pattern selector
        _patternDesignWidget.showTopLevel();

        // Close pattern modal (somehow need to reset it)
        $('.pattern-select').removeClass('active');
        $('.pattern-select').attr('data-slot', '');

        // Fade select modal back in
        $('.js-pattern-modal')[0].style.removeProperty('opacity');

    });

    $('.js-pattern-close').on('click', function () {
        $('.js-pattern-modal').removeClass('active');
        $('.overlay').removeClass('active');
    });

    $('.js-pattern-select-close').on('click', function () {
        $('.pattern-select').removeClass('active');
        $('.js-pattern-modal').attr('style', '');
    });

});

// Get Order ID from URL
function getOrderIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('order_id');
}

function closeArtworkModal() {

    if (window.artworkDropzone.getUploadingFiles().length > 0) {

        $('.js-artwork-modal').addClass('modal-faded');
        $('.js-are-you-sure-modal').addClass('active');

    } else {

        // Destroy dropzone on close
        window.artworkDropzone.destroy();

        // Close Modal
        $('.overlay').removeClass('active');
        $('.js-artwork-modal').removeClass('active');
        $('.upload-art-info__error').removeClass('active');

    }


}